package cc.bluepeak.clubmanager.enums

import kotlinx.serialization.Serializable

/**
 * Locales supported by the backend
 * */
@Serializable
enum class Locale(val value: String, val native: String) {
    English("en", "English"), German("de", "Deutsch");

    companion object {
        fun fromString(value: String) = entries.firstOrNull { it.value == value }
    }
}